import React from 'react';
import { Link } from 'react-router-dom';
//large logo
import Logo from '../components/logo/Logo';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
//style
import './confirm.styl'

class Confirm extends React.Component {
  render(){
    return(
      <div className='no-match-inner-container'>
        <SimpleContainer color='dark' containerClass='padded-container header-container'>
          <h1>Successfully signed up!</h1>
        </SimpleContainer>
        <SimpleContainer color='white' containerClass='padded-container confirm-message-container'>
          <h2>We sent you a confirmation email with a link to activate your account.
            <span className='highlight'> If you did not receive an email, please check your spam folder</span>
          </h2>
        </SimpleContainer>
        <h1>Back to</h1>
        <div className='confirm-logo-container'>
          <Link to='/'><Logo size='large' ver='unfolded' /></Link>
        </div>
        <p>It's safe to close this window now</p>
      </div>
    );
  }
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/routes/Confirm.js